export default "{% block verpackung_wertstoff_data_fields %}\n<div class=\"verpackung-wertstoff-data-fields\">\n\n</div>\n{% endblock %}";